import type { IconProps } from './types';
import './icons.css';

export default function IconLinkTwo({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-link-two ${className || ''}`}
    >
      <g fill="currentColor">
        <path d="M10.273 6.635 6.637 10.27a.643.643 0 0 1-.91-.91l3.637-3.636a.643.643 0 0 1 .909.91Z" />
        <path
          d="M8.357 3.096 7.091 4.362a.643.643 0 0 0 .91.909l1.286-1.286c.738-.739 1.953-.848 2.729-.149.828.745.853 
        2.021.075 2.799l-1.363 1.363a.643.643 0 0 0 .909.91L13 7.543a3.215 3.215 0 0
        0-.233-4.759c-1.295-1.069-3.223-.876-4.41.31ZM7.643 12.901l1.266-1.265a.643.643 0 0
        0-.909-.91l-1.286 1.287c-.738.738-1.953.848-2.73.148a1.928 1.928 0 0 1-.075-2.798l1.364-1.364a.643.643 0 0
        0-.91-.909L3 8.454a3.215 3.215 0 0 0 .234 4.758c1.294 1.069 3.222.877 4.41-.31Z"
        />
      </g>
    </svg>
  );
}
